import { BlurIcon } from "@dataone/icons";
import {
  IDataSource,
  ITopics,
  NotificationType,
  getTopics,
} from "@dataone/lib";
import { useMutation } from "@tanstack/react-query";
import { Skeleton } from "antd";
import { useEffect, useState } from "react";
import { styled } from "styled-components";
import { useAuth } from "../../../../../../auth/contexts/auth.provider";

interface DatabaseTopicsProps {
  selectedDB: IDataSource | null;
}

const DatabaseTopics = ({ selectedDB }: DatabaseTopicsProps) => {
  const [topics, setTopics] = useState<ITopics[]>([]);

  const { notifications } = useAuth();

  const { mutate: fetchTopics, isLoading } = useMutation(getTopics);

  useEffect(() => {
    if (
      selectedDB &&
      selectedDB.id &&
      selectedDB.dataSourceType === "DATABASE"
    ) {
      fetchTopics(selectedDB.id, {
        onSuccess: (data) => {
          setTopics(data);
        },
      });
    }
  }, [selectedDB, fetchTopics]);

  useEffect(() => {
    const lastNotification = notifications.at(-1);
    if (
      lastNotification?.type === NotificationType.TOPIC &&
      lastNotification.id === selectedDB?.id
    )
      setTopics(lastNotification.data);
  }, [notifications]);

  return (
    <StyledTopics
      exist={
        selectedDB !== null &&
        selectedDB.dataSourceType === "DATABASE" &&
        topics?.length !== 0
          ? true
          : false
      }
    >
      {isLoading ? (
        <StyledSkeleton>
          <Skeleton.Input
            active
            block
            size="small"
            style={{ width: "560px", marginBottom: "4px" }}
          />
          <Skeleton.Input
            active
            block
            size="small"
            style={{ width: "560px", marginBottom: "4px" }}
          />
          <Skeleton.Input
            active
            block
            size="small"
            style={{ width: "560px" }}
          />
        </StyledSkeleton>
      ) : (
        topics?.map((topic, index) => (
          <StyledDatabaseTopics key={index}>
            <div className="icon">
              <BlurIcon />
            </div>
            <div className="title">{topic.title}</div>
            <div className="description">{topic.description}</div>
          </StyledDatabaseTopics>
        ))
      )}
    </StyledTopics>
  );
};

export default DatabaseTopics;

const StyledDatabaseTopics = styled.div`
  margin: 5px;
  padding: 15px 10px;
  border-radius: 10px;
  background-color: #eff1fd;
  .icon {
    font-size: 20px;
  }
  .title {
    font-size: 14px;
    font-weight: 700;
  }
  .description {
    margin-top: 6px;
    font-size: 13px;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    overflow: hidden;
    width: 250px;
  }
`;

const StyledTopics = styled.div<{ exist: boolean }>`
  margin-top: 10px;
  padding-right: 10px;
  display: ${(props) => (props.exist ? "flex" : "none")};
  flex-direction: row;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 0px;
  }
`;

const StyledSkeleton = styled.div``;
